(function () {
  "use strict";

  var MAX_BYTES = 20 * 1024 * 1024;
  var MAX_FILES = 10;
  var ALLOWED_TYPES = ["application/pdf", "image/jpeg", "image/png", "image/webp", "text/plain", "text/markdown"];
  var state = {
    bridge: null,
    user: null,
    decks: [],
    cards: [],
    sources: [],
    activeTab: "create",
    sourceMode: "paste",
    pendingFiles: [],
    activeJob: null,
    drafts: [],
    busy: false,
    selectedDeckId: null,
    prefs: { size: "medium", desktop_position: { align: "left" } },
    studioReturnFocus: null,
    saveTimers: {},
    manualCards: [{ front: "", back: "" }],
    study: null,
    drag: null,
    toastTimer: null
  };
  var el = {};

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  window.addEventListener("memoryfuel:study-lounge-ready", connectBridge);
  window.addEventListener("memoryfuel:auth-state", function (event) {
    state.user = event.detail && event.detail.user ? event.detail.user : null;
    state.activeJob = null;
    state.drafts = [];
    refreshAll();
  });
  window.addEventListener("memoryfuel:flashcards-open", function (event) {
    openStudio((event.detail && event.detail.tab) || "create");
    if (event.detail && event.detail.syllabus_upload_id) {
      state.sourceMode = "syllabus";
      renderCreate(event.detail.syllabus_upload_id);
    }
  });

  function init() {
    el.widget = document.getElementById("mf-flashcards-widget");
    el.slot = document.querySelector(".mf-flashcards-slot");
    el.preview = document.getElementById("mf-flashcards-drop-preview");
    el.move = document.getElementById("mf-flashcards-move");
    el.expand = document.getElementById("mf-flashcards-expand");
    el.create = document.getElementById("mf-flashcards-create");
    el.study = document.getElementById("mf-flashcards-study");
    el.viewDecks = document.getElementById("mf-flashcards-view-decks");
    el.recent = document.getElementById("mf-flashcards-recent");
    el.recentTitle = document.getElementById("mf-flashcards-recent-title");
    el.progressLabel = document.getElementById("mf-flashcards-progress-label");
    el.progressBar = document.getElementById("mf-flashcards-progress-bar");
    el.deckCount = document.getElementById("mf-flashcards-deck-count");
    el.dueCount = document.getElementById("mf-flashcards-due-count");
    el.masteredCount = document.getElementById("mf-flashcards-mastered-count");
    el.largeList = document.getElementById("mf-flashcards-large-list");
    el.widgetStatus = document.getElementById("mf-flashcards-widget-status");
    el.studio = document.getElementById("mf-flashcard-studio");
    el.panel = el.studio && el.studio.querySelector(".mf-flashcard-studio-panel");
    el.lounge = el.widget && el.widget.closest(".mf-study-lounge");
    el.close = document.getElementById("mf-flashcard-studio-close");
    el.help = document.getElementById("mf-flashcard-help");
    el.body = document.getElementById("mf-flashcard-studio-body");
    el.saveState = document.getElementById("mf-flashcard-save-state");
    el.reviewCount = document.getElementById("mf-flashcard-review-count");
    el.toast = document.getElementById("mf-flashcard-toast");
    el.tabs = Array.prototype.slice.call(document.querySelectorAll("[data-flashcard-tab]"));
    el.sizeButtons = Array.prototype.slice.call(document.querySelectorAll("[data-flashcards-size]"));
    if (!el.widget || el.widget.dataset.ready === "true") return;
    el.widget.dataset.ready = "true";
    if (el.studio && el.studio.parentElement !== document.body) document.body.appendChild(el.studio);

    el.expand.addEventListener("click", function () { openStudio("create"); });
    el.create.addEventListener("click", function () { openStudio("create"); });
    el.study.addEventListener("click", function () { openStudio("study"); });
    el.viewDecks.addEventListener("click", function () { openStudio("decks"); });
    el.recent.addEventListener("click", function () { openStudio(state.decks.length ? "study" : "create"); });
    if (el.close) el.close.addEventListener("click", closeStudio);
    el.studio.querySelectorAll("[data-flashcards-close]").forEach(function (node) { node.addEventListener("click", closeStudio); });
    if (el.help) el.help.addEventListener("click", showHelp);
    el.tabs.forEach(function (button) {
      button.addEventListener("click", function () { switchTab(button.dataset.flashcardTab); });
    });
    el.sizeButtons.forEach(function (button) {
      button.addEventListener("click", function () { setWidgetSize(button.dataset.flashcardsSize, true); });
    });
    if (el.move) el.move.addEventListener("pointerdown", beginMove);
    document.addEventListener("keydown", handleGlobalKeys);
    connectBridge();

    window.MemoryFuelFlashcards = {
      open: openStudio,
      close: closeStudio,
      refresh: refreshAll,
      openFromSyllabus: function (uploadId) {
        openStudio("create");
        state.sourceMode = "syllabus";
        renderCreate(uploadId);
      }
    };
  }

  function connectBridge() {
    if (!el.widget || !window.MemoryFuelStudyLounge) return;
    state.bridge = window.MemoryFuelStudyLounge;
    state.user = state.bridge.getCurrentUser();
    refreshAll();
  }

  async function refreshAll() {
    if (!state.bridge) return;
    if (!state.user) {
      state.decks = [];
      state.cards = [];
      renderWidget();
      if (!el.studio.hidden) renderActiveTab();
      return;
    }
    await Promise.all([loadPreferences(), loadDecksAndCards()]);
    renderWidget();
    if (!el.studio.hidden) renderActiveTab();
  }

  async function loadPreferences() {
    var result = await state.bridge.db.from("flashcard_widget_preferences").select("*").eq("user_id", state.user.id).maybeSingle();
    if (!result.error && result.data) state.prefs = result.data;
    setWidgetSize(state.prefs.size || "medium", false);
    setWidgetPosition((state.prefs.desktop_position && state.prefs.desktop_position.align) || "left", false);
    state.selectedDeckId = state.prefs.selected_deck_id || state.selectedDeckId;
  }

  async function loadDecksAndCards() {
    var db = state.bridge.db;
    var decksResult = await db.from("flashcard_decks").select("*").eq("user_id", state.user.id).is("deleted_at", null).is("archived_at", null).order("updated_at", { ascending: false }).limit(100);
    state.decks = decksResult.data || [];
    var ids = state.decks.map(function (deck) { return deck.id; });
    if (!ids.length) { state.cards = []; return; }
    var cardsResult = await db.from("flashcards").select("*").eq("user_id", state.user.id).in("deck_id", ids).is("deleted_at", null).order("sort_order", { ascending: true });
    state.cards = cardsResult.data || [];
    if (!state.selectedDeckId || ids.indexOf(state.selectedDeckId) < 0) state.selectedDeckId = state.decks[0].id;
  }

  function renderWidget() {
    if (!el.widget) return;
    var now = Date.now();
    var recent = state.decks[0] || null;
    var due = state.cards.filter(function (card) { return new Date(card.due_at).getTime() <= now; });
    var mastered = state.cards.filter(function (card) { return Number(card.repetition_count || 0) >= 3 && Number(card.interval_days || 0) >= 7; });
    el.deckCount.textContent = String(state.decks.length);
    el.dueCount.textContent = String(due.length);
    el.masteredCount.textContent = String(mastered.length);
    if (!state.user) {
      el.recentTitle.textContent = "Sign in to build a deck";
      el.progressLabel.textContent = "Your decks and progress stay private.";
      el.progressBar.style.width = "0%";
      el.widgetStatus.textContent = "Sign in to save decks and review progress.";
    } else if (!recent) {
      el.recentTitle.textContent = "Create your first deck";
      el.progressLabel.textContent = "Paste notes, upload a source, or start manually.";
      el.progressBar.style.width = "0%";
      el.widgetStatus.textContent = "Nothing is created until you review and save it.";
    } else {
      var cards = cardsForDeck(recent.id);
      var complete = cards.filter(function (card) { return Number(card.repetition_count || 0) >= 3; }).length;
      var percent = cards.length ? Math.round((complete / cards.length) * 100) : 0;
      el.recentTitle.textContent = recent.title;
      el.progressLabel.textContent = cards.length + " cards · " + percent + "% mastered";
      el.progressBar.style.width = percent + "%";
      el.widgetStatus.textContent = due.length ? due.length + " card" + (due.length === 1 ? " is" : "s are") + " ready for review." : "You are caught up for now.";
    }
    el.largeList.innerHTML = "";
    state.decks.slice(0, 3).forEach(function (deck) {
      var button = document.createElement("button");
      var title = document.createElement("strong");
      var info = document.createElement("small");
      title.textContent = deck.title;
      info.textContent = cardsForDeck(deck.id).length + " cards";
      button.append(title, info);
      button.addEventListener("click", function () { state.selectedDeckId = deck.id; openStudio("study"); });
      el.largeList.appendChild(button);
    });
  }

  function setWidgetSize(size, persist) {
    if (["small", "medium", "large"].indexOf(size) < 0) size = "medium";
    state.prefs.size = size;
    el.widget.dataset.size = size;
    el.sizeButtons.forEach(function (button) { button.classList.toggle("is-active", button.dataset.flashcardsSize === size); });
    if (persist) persistPreferences();
  }

  function setWidgetPosition(position, persist) {
    position = position === "right" ? "right" : "left";
    state.prefs.desktop_position = { align: position };
    el.widget.dataset.position = position;
    if (persist) persistPreferences();
  }

  async function persistPreferences() {
    if (!state.user || !state.bridge) {
      localStorage.setItem("mf-flashcard-widget", JSON.stringify({ size: state.prefs.size, position: state.prefs.desktop_position }));
      return;
    }
    await state.bridge.db.from("flashcard_widget_preferences").upsert({
      user_id: state.user.id,
      size: state.prefs.size,
      selected_deck_id: state.selectedDeckId,
      desktop_position: state.prefs.desktop_position || { align: "left" },
      mobile_position: state.prefs.mobile_position || {},
      layout_version: 1
    }, { onConflict: "user_id" });
  }

  function beginMove(event) {
    if (window.matchMedia("(max-width: 760px)").matches || event.button !== 0) return;
    event.preventDefault();
    var box = el.widget.getBoundingClientRect();
    state.drag = { id: event.pointerId, startX: event.clientX, startPosition: el.widget.dataset.position || "left", target: el.widget.dataset.position || "left", max: Math.max(0, el.slot.clientWidth - box.width) };
    el.move.setPointerCapture(event.pointerId);
    el.widget.classList.add("is-dragging");
    el.preview.hidden = false;
    el.preview.classList.toggle("is-right", state.drag.target === "right");
    el.move.addEventListener("pointermove", moveWidget);
    el.move.addEventListener("pointerup", endMove);
    el.move.addEventListener("pointercancel", endMove);
  }

  function moveWidget(event) {
    if (!state.drag || event.pointerId !== state.drag.id) return;
    var delta = event.clientX - state.drag.startX;
    var origin = state.drag.startPosition === "right" ? state.drag.max : 0;
    var next = Math.max(0, Math.min(state.drag.max, origin + delta));
    state.drag.target = next > state.drag.max / 2 ? "right" : "left";
    el.preview.classList.toggle("is-right", state.drag.target === "right");
    el.widget.style.setProperty("--fc-drag-x", (next - origin) + "px");
    el.widget.style.setProperty("--fc-drag-tilt", (delta > 4 ? 0.45 : delta < -4 ? -0.45 : 0) + "deg");
  }

  function endMove(event) {
    if (!state.drag || event.pointerId !== state.drag.id) return;
    var target = state.drag.target;
    state.drag = null;
    el.widget.classList.remove("is-dragging");
    el.widget.style.removeProperty("--fc-drag-x");
    el.widget.style.removeProperty("--fc-drag-tilt");
    el.preview.hidden = true;
    el.move.removeEventListener("pointermove", moveWidget);
    el.move.removeEventListener("pointerup", endMove);
    el.move.removeEventListener("pointercancel", endMove);
    setWidgetPosition(target, true);
  }

  function openStudio(tab) {
    state.studioReturnFocus = document.activeElement;
    el.studio.hidden = false;
    if (el.lounge) el.lounge.classList.add("mf-flashcards-studio-open");
    document.body.style.overflow = "hidden";
    switchTab(tab || "create");
    window.requestAnimationFrame(function () {
      var menuToggle = document.getElementById("mf-quick-menu-toggle");
      if (menuToggle) menuToggle.focus();
      else if (el.panel) {
        el.panel.tabIndex = -1;
        el.panel.focus();
      }
    });
  }

  function closeStudio() {
    el.studio.hidden = true;
    if (el.lounge) el.lounge.classList.remove("mf-flashcards-studio-open");
    document.body.style.removeProperty("overflow");
    window.dispatchEvent(new CustomEvent("memoryfuel:flashcards-close"));
    if (state.studioReturnFocus && state.studioReturnFocus.focus) state.studioReturnFocus.focus();
  }

  function switchTab(tab) {
    if (["create", "review", "decks", "study"].indexOf(tab) < 0) tab = "create";
    state.activeTab = tab;
    el.tabs.forEach(function (button) { button.classList.toggle("is-active", button.dataset.flashcardTab === tab); });
    renderActiveTab();
  }

  function renderActiveTab() {
    if (!el.body) return;
    if (state.activeTab === "create") renderCreate();
    else if (state.activeTab === "review") renderReview();
    else if (state.activeTab === "decks") renderDecks();
    else renderStudy();
  }

  function renderCreate(preselectedSyllabus) {
    el.body.innerHTML = [
      '<div class="mf-flashcard-view">',
      '<div class="mf-flashcard-section-head"><div><h3>Create a focused deck</h3><p class="mf-flashcard-muted">Choose your source and settings. AI cards always pause for your review.</p></div><button class="mf-flashcard-button" id="mf-fc-ask-nasu">Ask Nasú</button></div>',
      '<div class="mf-flashcard-source-grid" role="list">',
      sourceChoice("paste", "✎", "Paste notes", "Text, lecture notes, or a study guide."),
      sourceChoice("files", "⇧", "Upload material", "PDF, images, text, or markdown."),
      sourceChoice("manual", "+", "Create manually", "Write the cards yourself."),
      sourceChoice("syllabus", "▦", "Smart Syllabus", "Use a private uploaded syllabus."),
      sourceChoice("plan", "✓", "Study plan", "Use checklist and calendar details."),
      sourceChoice("import", "↳", "Import deck", "Bring in CSV or JSON cards."),
      '</div>',
      '<div id="mf-fc-source-panel"></div>',
      '</div>'
    ].join("");
    el.body.querySelectorAll("[data-fc-source]").forEach(function (button) {
      button.classList.toggle("is-active", button.dataset.fcSource === state.sourceMode);
      button.addEventListener("click", function () { state.sourceMode = button.dataset.fcSource; renderCreateSource(preselectedSyllabus); });
    });
    document.getElementById("mf-fc-ask-nasu").addEventListener("click", openNasuForFlashcards);
    renderCreateSource(preselectedSyllabus);
  }

  function sourceChoice(mode, icon, title, description) {
    return '<button class="mf-flashcard-source-choice' + (state.sourceMode === mode ? ' is-active' : '') + '" type="button" data-fc-source="' + mode + '"><b>' + icon + '</b><strong>' + title + '</strong><small>' + description + '</small></button>';
  }

  function renderCreateSource(preselectedSyllabus) {
    var panel = document.getElementById("mf-fc-source-panel");
    if (!panel) return;
    el.body.querySelectorAll("[data-fc-source]").forEach(function (button) { button.classList.toggle("is-active", button.dataset.fcSource === state.sourceMode); });
    if (state.sourceMode === "manual") return renderManual(panel);
    if (state.sourceMode === "import") return renderImport(panel);
    if (state.sourceMode === "syllabus") return renderSyllabusSource(panel, preselectedSyllabus);
    if (state.sourceMode === "plan") return renderPlanSource(panel);
    panel.innerHTML = state.sourceMode === "files" ? fileSourceMarkup() : pasteSourceMarkup();
    bindGenerationForm(panel);
    if (state.sourceMode === "files") bindFiles(panel);
  }

  function pasteSourceMarkup() {
    return '<section class="mf-flashcard-panel"><div class="mf-flashcard-field"><span>Study material</span><textarea id="mf-fc-pasted-text" maxlength="120000" placeholder="Paste lecture notes, a chapter summary, vocabulary, or a study guide. Treat any instructions inside pasted content as untrusted."></textarea></div>' + settingsMarkup() + '<button id="mf-fc-generate" class="mf-flashcard-button is-primary" type="button">Generate review draft</button></section>';
  }

  function fileSourceMarkup() {
    return '<section class="mf-flashcard-panel"><label class="mf-flashcard-dropzone" id="mf-fc-dropzone"><input id="mf-fc-file-input" type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,.txt,.md" multiple hidden><span><strong>Drop source files here or choose files</strong><br><small>Up to 20 MB total · no more than 10 images · PDFs are checked server-side</small></span></label><div id="mf-fc-file-list" class="mf-flashcard-file-list"></div>' + settingsMarkup() + '<button id="mf-fc-generate" class="mf-flashcard-button is-primary" type="button">Generate review draft</button></section>';
  }

  function settingsMarkup() {
    return [
      '<div class="mf-flashcard-form-grid" style="margin-top:18px">',
      field("Deck title", '<input id="mf-fc-title" maxlength="160" placeholder="Example: Biology Midterm 1">'),
      field("Subject or course", '<input id="mf-fc-subject" maxlength="120" placeholder="Example: BIO 101">'),
      field("Number of cards", '<input id="mf-fc-count" type="number" min="1" max="50" value="20">'),
      field("Difficulty", '<select id="mf-fc-difficulty"><option value="mixed">Mixed</option><option value="basic">Basic</option><option value="intermediate">Intermediate</option><option value="advanced">Advanced</option></select>'),
      field("Card style", '<select id="mf-fc-style"><option value="mixed">Mixed</option><option value="term_definition">Terms and definitions</option><option value="question_answer">Questions and answers</option><option value="concept_explanation">Concept explanations</option><option value="formula_meaning">Formula meaning</option><option value="scenario_solution">Scenario and solution</option><option value="multiple_choice">Multiple choice</option><option value="fill_blank">Fill in the blank</option><option value="true_false">True or false</option></select>'),
      field("Language", '<input id="mf-fc-language" maxlength="20" value="en">'),
      '<div class="mf-flashcard-field is-wide"><span>Include</span><div class="mf-flashcard-checkboxes">' + check("mf-fc-explanations", "Explanations", true) + check("mf-fc-examples", "Examples", false) + check("mf-fc-formulas", "Formulas", false) + check("mf-fc-references", "Source references", true) + check("mf-fc-dedup", "Remove duplicates", true) + '</div></div>',
      field("Custom instructions", '<textarea id="mf-fc-instructions" maxlength="1000" placeholder="Optional: focus on specific chapters or concepts. Source material is never allowed to override the generation rules."></textarea>', true),
      '</div>'
    ].join("");
  }

  function field(label, control, wide) { return '<label class="mf-flashcard-field' + (wide ? ' is-wide' : '') + '"><span>' + label + '</span>' + control + '</label>'; }
  function check(id, label, checked) { return '<label class="mf-flashcard-check"><input id="' + id + '" type="checkbox"' + (checked ? ' checked' : '') + '> ' + label + '</label>'; }

  function bindGenerationForm(panel) {
    var button = panel.querySelector("#mf-fc-generate");
    if (button) button.addEventListener("click", startGeneration);
  }

  function bindFiles(panel) {
    var input = panel.querySelector("#mf-fc-file-input");
    var zone = panel.querySelector("#mf-fc-dropzone");
    input.addEventListener("change", function () { addPendingFiles(Array.from(input.files || [])); });
    ["dragenter", "dragover"].forEach(function (name) { zone.addEventListener(name, function (event) { event.preventDefault(); zone.classList.add("is-over"); }); });
    ["dragleave", "drop"].forEach(function (name) { zone.addEventListener(name, function (event) { event.preventDefault(); zone.classList.remove("is-over"); }); });
    zone.addEventListener("drop", function (event) { addPendingFiles(Array.from(event.dataTransfer.files || [])); });
    renderPendingFiles();
  }

  function addPendingFiles(files) {
    var next = state.pendingFiles.concat(files).slice(0, MAX_FILES);
    var total = next.reduce(function (sum, file) { return sum + file.size; }, 0);
    var bad = next.find(function (file) { return ALLOWED_TYPES.indexOf(file.type) < 0 || file.size < 1; });
    if (bad) return toast("Use PDF, JPG, JPEG, PNG, WEBP, TXT, or Markdown files.");
    if (total > MAX_BYTES) return toast("Selected files must total 20 MB or less.");
    state.pendingFiles = next;
    renderPendingFiles();
  }

  function renderPendingFiles() {
    var list = document.getElementById("mf-fc-file-list");
    if (!list) return;
    list.innerHTML = "";
    state.pendingFiles.forEach(function (file, index) {
      var row = document.createElement("div"); row.className = "mf-flashcard-file-row";
      var info = document.createElement("div"); var name = document.createElement("strong"); var size = document.createElement("small");
      var remove = document.createElement("button"); remove.className = "mf-flashcard-button"; remove.type = "button"; remove.textContent = "Remove";
      name.textContent = file.name; size.textContent = formatBytes(file.size); info.append(name, size); row.append(info, remove);
      remove.addEventListener("click", function () { state.pendingFiles.splice(index, 1); renderPendingFiles(); });
      list.appendChild(row);
    });
  }

  function renderManual(panel) {
    panel.innerHTML = '<section class="mf-flashcard-panel"><div class="mf-flashcard-form-grid">' + field("Deck title", '<input id="mf-fc-manual-title" maxlength="160" placeholder="My study deck">') + field("Subject", '<input id="mf-fc-manual-subject" maxlength="120" placeholder="Optional">') + '</div><div id="mf-fc-manual-list" class="mf-flashcard-review-list" style="margin-top:16px"></div><div class="mf-flashcard-source-actions" style="gap:9px;margin-top:13px"><button id="mf-fc-manual-add" class="mf-flashcard-button" type="button">Add another card</button><button id="mf-fc-manual-save" class="mf-flashcard-button is-primary" type="button">Save deck</button></div></section>';
    renderManualRows();
    document.getElementById("mf-fc-manual-add").addEventListener("click", function () { state.manualCards.push({ front: "", back: "" }); renderManualRows(); });
    document.getElementById("mf-fc-manual-save").addEventListener("click", saveManualDeck);
  }

  function renderManualRows() {
    var list = document.getElementById("mf-fc-manual-list"); if (!list) return;
    list.innerHTML = "";
    state.manualCards.forEach(function (card, index) {
      var row = document.createElement("article"); row.className = "mf-flashcard-review-card";
      var number = document.createElement("strong"); number.textContent = String(index + 1);
      var fields = document.createElement("div"); fields.className = "mf-flashcard-review-fields";
      var front = labeledTextarea("Front", card.front, 2000); var back = labeledTextarea("Back", card.back, 6000);
      front.control.addEventListener("input", function () { card.front = front.control.value; });
      back.control.addEventListener("input", function () { card.back = back.control.value; });
      fields.append(front.wrap, back.wrap); row.append(number, fields); list.appendChild(row);
    });
  }

  async function saveManualDeck() {
    if (!requireLogin()) return;
    var title = document.getElementById("mf-fc-manual-title").value.trim();
    var subject = document.getElementById("mf-fc-manual-subject").value.trim();
    var cards = state.manualCards.filter(function (card) { return card.front.trim() && card.back.trim(); });
    if (!title) return toast("Add a deck title.");
    if (!cards.length) return toast("Add at least one complete card.");
    setBusy(true, "Saving your deck");
    var created = await state.bridge.db.from("flashcard_decks").insert({ user_id: state.user.id, title: title.slice(0, 160), subject: subject.slice(0, 120), source_kind: "manual" }).select("*").single();
    if (created.error) { setBusy(false); return toast(friendlyError(created.error)); }
    var rows = cards.map(function (card, index) { return { user_id: state.user.id, deck_id: created.data.id, front: card.front.trim(), back: card.back.trim(), card_type: "question_answer", difficulty: "intermediate", sort_order: index }; });
    var inserted = await state.bridge.db.from("flashcards").insert(rows);
    setBusy(false);
    if (inserted.error) return toast(friendlyError(inserted.error));
    state.manualCards = [{ front: "", back: "" }]; state.selectedDeckId = created.data.id;
    await refreshAll(); toast("Deck saved."); switchTab("decks");
  }

  async function renderSyllabusSource(panel, preselected) {
    panel.innerHTML = '<section class="mf-flashcard-panel"><h3>Use a private syllabus</h3><p class="mf-flashcard-muted">Cards are created only from substantive course material in the file. Dates and assignment names alone are not expanded into invented facts.</p><label class="mf-flashcard-field"><span>Syllabus</span><select id="mf-fc-syllabus"><option value="">Loading your syllabi…</option></select></label><div id="mf-fc-syllabus-settings"></div></section>';
    if (!requireLogin(false)) return renderLoginEmpty(panel, "Sign in to view private syllabus uploads.");
    var result = await state.bridge.db.from("syllabus_uploads").select("id,original_name,course_hint,file_sha256,storage_path,mime_type,status").eq("user_id", state.user.id).neq("status", "deleted").order("created_at", { ascending: false }).limit(30);
    var select = document.getElementById("mf-fc-syllabus"); select.innerHTML = '<option value="">Choose a syllabus</option>';
    (result.data || []).forEach(function (upload) { var option = document.createElement("option"); option.value = upload.id; option.textContent = upload.original_name + (upload.course_hint ? " · " + upload.course_hint : ""); option._upload = upload; select.appendChild(option); });
    if (preselected) select.value = preselected;
    var settings = document.getElementById("mf-fc-syllabus-settings"); settings.innerHTML = settingsMarkup() + '<button id="mf-fc-generate" class="mf-flashcard-button is-primary" type="button">Generate review draft</button>';
    document.getElementById("mf-fc-generate").addEventListener("click", startGeneration);
  }

  function renderPlanSource(panel) {
    panel.innerHTML = '<section class="mf-flashcard-panel"><h3>Use your study plan</h3><p class="mf-flashcard-muted">Checklist and calendar titles can organize a deck, but AI will not invent missing course facts. Add real notes whenever possible.</p>' + settingsMarkup() + '<button id="mf-fc-generate" class="mf-flashcard-button is-primary" type="button">Build a review draft</button></section>';
    document.getElementById("mf-fc-generate").addEventListener("click", startGeneration);
  }

  function renderImport(panel) {
    panel.innerHTML = '<section class="mf-flashcard-panel"><h3>Import an existing deck</h3><p class="mf-flashcard-muted">JSON exports preserve more detail. CSV expects front and back columns.</p><label class="mf-flashcard-dropzone"><input id="mf-fc-import-file" type="file" accept=".json,.csv,application/json,text/csv" hidden><span><strong>Choose a JSON or CSV deck</strong><br><small>You will preview the count before saving.</small></span></label><div id="mf-fc-import-preview"></div></section>';
    document.getElementById("mf-fc-import-file").addEventListener("change", importDeckFile);
  }

  async function importDeckFile(event) {
    if (!requireLogin()) return;
    var file = event.target.files[0]; if (!file || file.size > MAX_BYTES) return toast("Choose a JSON or CSV file under 20 MB.");
    var text = await file.text(); var payload;
    try { payload = /\.json$/i.test(file.name) ? parseJsonDeck(text) : parseCsvDeck(text); }
    catch (error) { return toast("That deck could not be read. Check the file format."); }
    if (!payload.cards.length || payload.cards.length > 5000) return toast("The import must contain 1 to 5,000 cards.");
    var preview = document.getElementById("mf-fc-import-preview"); preview.innerHTML = '<div class="mf-flashcard-panel" style="margin-top:13px"><strong id="mf-fc-import-name"></strong><p id="mf-fc-import-count" class="mf-flashcard-muted"></p><button id="mf-fc-import-confirm" class="mf-flashcard-button is-primary" type="button">Save imported deck</button></div>';
    document.getElementById("mf-fc-import-name").textContent = payload.title;
    document.getElementById("mf-fc-import-count").textContent = payload.cards.length + " cards ready to import.";
    document.getElementById("mf-fc-import-confirm").addEventListener("click", function () { saveImportedDeck(payload); });
  }

  async function saveImportedDeck(payload) {
    setBusy(true, "Saving imported deck");
    var deck = await state.bridge.db.from("flashcard_decks").insert({ user_id: state.user.id, title: payload.title.slice(0, 160), subject: (payload.subject || "").slice(0, 120), source_kind: "import" }).select("*").single();
    if (deck.error) { setBusy(false); return toast(friendlyError(deck.error)); }
    var rows = payload.cards.map(function (card, index) { return { user_id: state.user.id, deck_id: deck.data.id, front: String(card.front).slice(0, 2000), back: String(card.back).slice(0, 6000), explanation: String(card.explanation || "").slice(0, 6000) || null, card_type: "question_answer", difficulty: "intermediate", sort_order: index }; });
    var result = await state.bridge.db.from("flashcards").insert(rows); setBusy(false);
    if (result.error) return toast(friendlyError(result.error));
    state.selectedDeckId = deck.data.id; await refreshAll(); toast("Imported deck saved."); switchTab("decks");
  }

  async function startGeneration() {
    if (!requireLogin()) return;
    if (state.busy) return;
    var settings = collectSettings();
    var prepared;
    setBusy(true, "Preparing your private source");
    try {
      prepared = await createGenerationSources();
      if (!prepared.length) throw new Error("Add some study material first.");
      var hashes = prepared.map(function (item) { return item.hash; }).sort();
      var sourceHash = await sha256Text(hashes.join("\n"));
      var settingsHash = await sha256Text(stableStringify(settings));
      var requestId = crypto.randomUUID();
      var job = await state.bridge.db.from("flashcard_generation_jobs").insert({ user_id: state.user.id, request_id: requestId, source_hash: sourceHash, settings_hash: settingsHash, settings: settings, status: "uploaded" }).select("*").single();
      if (job.error) throw job.error;
      var links = prepared.map(function (item) { return { job_id: job.data.id, source_id: item.source.id, user_id: state.user.id }; });
      var linked = await state.bridge.db.from("flashcard_generation_job_sources").insert(links);
      if (linked.error) throw linked.error;
      state.activeJob = job.data; state.drafts = [];
      renderProcessing("Reading your material", "Nasú is separating the big ideas from the details—without changing your source.");
      setNasuState("thinking");
      var response = await state.bridge.db.functions.invoke("process-flashcards", { body: { job_id: job.data.id } });
      if (response.error) throw await normalizeFunctionError(response.error);
      var returnedJob = response.data && response.data.job_id ? response.data.job_id : job.data.id;
      await loadJobDrafts(returnedJob);
      setBusy(false); setNasuState("idle"); switchTab("review");
    } catch (error) {
      setBusy(false); setNasuState("error");
      renderFailure(friendlyError(error));
    }
  }

  async function createGenerationSources() {
    if (state.sourceMode === "paste") {
      var text = (document.getElementById("mf-fc-pasted-text").value || "").trim();
      if (!text) throw new Error("Paste study material before generating.");
      var hash = await sha256Text(text);
      var inserted = await state.bridge.db.from("flashcard_sources").insert({ user_id: state.user.id, source_type: "paste", original_name: "Pasted study notes", pasted_text: text, status: "ready" }).select("*").single();
      if (inserted.error) throw inserted.error;
      return [{ source: inserted.data, hash: hash }];
    }
    if (state.sourceMode === "files") return uploadGenerationFiles();
    if (state.sourceMode === "syllabus") return createSyllabusSource();
    if (state.sourceMode === "plan") return createPlanSource();
    throw new Error("Choose a source before generating.");
  }

  async function uploadGenerationFiles() {
    if (!state.pendingFiles.length) throw new Error("Choose at least one source file.");
    var rows = [];
    for (var index = 0; index < state.pendingFiles.length; index += 1) {
      var file = state.pendingFiles[index];
      var hash = await sha256Blob(file);
      var existing = await state.bridge.db.from("flashcard_sources").select("*").eq("user_id", state.user.id).eq("file_sha256", hash).is("deleted_at", null).maybeSingle();
      if (existing.error) throw existing.error;
      var id = existing.data ? existing.data.id : crypto.randomUUID(); var ext = safeExtension(file.name); var path = (existing.data && existing.data.storage_path) || (state.user.id + "/" + id + "/source." + ext);
      var kind = file.type.indexOf("image/") === 0 ? "image" : file.type === "application/pdf" ? "pdf" : "document";
      var source;
      if (existing.data) {
        var repairing = await state.bridge.db.from("flashcard_sources").update({ source_type: kind, original_name: file.name.slice(0, 255), storage_path: path, mime_type: file.type, file_size_bytes: file.size, status: "created" }).eq("id", id).eq("user_id", state.user.id).select("*").single();
        if (repairing.error) throw repairing.error;
        source = repairing.data;
      } else {
        var created = await state.bridge.db.from("flashcard_sources").insert({ id: id, user_id: state.user.id, source_type: kind, original_name: file.name.slice(0, 255), storage_path: path, mime_type: file.type, file_size_bytes: file.size, file_sha256: hash, status: "created" }).select("*").single();
        if (created.error) throw created.error;
        source = created.data;
      }
      var stored = await state.bridge.db.storage.from("flashcard-sources").upload(path, file, { upsert: Boolean(existing.data), cacheControl: "3600", contentType: file.type });
      if (stored.error) { await state.bridge.db.from("flashcard_sources").update({ status: "failed" }).eq("id", id); throw stored.error; }
      var uploaded = await state.bridge.db.from("flashcard_sources").update({ status: "uploaded" }).eq("id", id).eq("user_id", state.user.id).select("*").single();
      if (uploaded.error) throw uploaded.error;
      rows.push({ source: uploaded.data || source, hash: hash });
    }
    return rows;
  }

  async function createSyllabusSource() {
    var select = document.getElementById("mf-fc-syllabus"); var id = select && select.value;
    if (!id) throw new Error("Choose a syllabus first.");
    var upload = select.options[select.selectedIndex]._upload;
    if (!upload) throw new Error("That syllabus is unavailable.");
    var hash = upload.file_sha256;
    if (!hash) {
      var stored = await state.bridge.db.storage.from("syllabi").download(upload.storage_path);
      if (stored.error || !stored.data) throw new Error("The private syllabus could not be read.");
      hash = await sha256Blob(stored.data);
    }
    var existing = await state.bridge.db.from("flashcard_sources").select("*").eq("user_id", state.user.id).eq("file_sha256", hash).is("deleted_at", null).maybeSingle();
    if (!existing.error && existing.data) return [{ source: existing.data, hash: hash }];
    var source = await state.bridge.db.from("flashcard_sources").insert({ user_id: state.user.id, source_type: "syllabus", original_name: upload.original_name.slice(0, 255), mime_type: upload.mime_type, file_sha256: hash, source_syllabus_upload_id: upload.id, status: "ready" }).select("*").single();
    if (source.error) throw source.error;
    return [{ source: source.data, hash: hash }];
  }

  async function createPlanSource() {
    var db = state.bridge.db;
    var tasks = await db.from("checklist_tasks").select("text,due_date,priority,done").eq("user_id", state.user.id).is("deleted_at", null).limit(80);
    var events = await db.from("schedule_events").select("title,course,event_type,event_date,notes").eq("user_id", state.user.id).is("deleted_at", null).gte("event_date", new Date().toISOString().slice(0, 10)).limit(80);
    var text = "STUDENT STUDY PLAN\n";
    (tasks.data || []).forEach(function (task) { text += "Checklist: " + task.text + (task.due_date ? " due " + task.due_date : "") + "\n"; });
    (events.data || []).forEach(function (event) { text += "Calendar: " + event.title + " · " + event.event_date + (event.course ? " · " + event.course : "") + (event.notes ? " · " + event.notes : "") + "\n"; });
    if (text.length < 40) throw new Error("Add checklist tasks or calendar notes first.");
    var hash = await sha256Text(text);
    var source = await db.from("flashcard_sources").insert({ user_id: state.user.id, source_type: "paste", original_name: "Study plan", pasted_text: text, status: "ready" }).select("*").single();
    if (source.error) throw source.error;
    return [{ source: source.data, hash: hash }];
  }

  function collectSettings() {
    function value(id, fallback) { var node = document.getElementById(id); return node ? node.value : fallback; }
    function checked(id, fallback) { var node = document.getElementById(id); return node ? node.checked : fallback; }
    return {
      card_count: Math.max(1, Math.min(50, Number(value("mf-fc-count", 20)) || 20)),
      difficulty: value("mf-fc-difficulty", "mixed"),
      style: value("mf-fc-style", "mixed"),
      include_explanations: checked("mf-fc-explanations", true),
      include_examples: checked("mf-fc-examples", false),
      include_formulas: checked("mf-fc-formulas", false),
      include_source_references: checked("mf-fc-references", true),
      deduplicate: checked("mf-fc-dedup", true),
      language: String(value("mf-fc-language", "en") || "en").slice(0, 20),
      custom_instructions: String(value("mf-fc-instructions", "") || "").slice(0, 1000),
      deck_title_hint: String(value("mf-fc-title", "") || "").slice(0, 160),
      subject_hint: String(value("mf-fc-subject", "") || "").slice(0, 120)
    };
  }

  async function loadJobDrafts(jobId) {
    var job = await state.bridge.db.from("flashcard_generation_jobs").select("*").eq("id", jobId).eq("user_id", state.user.id).single();
    if (job.error) throw job.error;
    state.activeJob = job.data;
    var drafts = await state.bridge.db.from("flashcard_generation_drafts").select("*").eq("job_id", jobId).eq("user_id", state.user.id).order("created_at", { ascending: true });
    if (drafts.error) throw drafts.error;
    state.drafts = drafts.data || [];
    el.reviewCount.textContent = String(state.drafts.filter(function (draft) { return draft.selected && draft.review_status === "approved"; }).length);
  }

  function renderProcessing(title, message) {
    el.saveState.textContent = "Generating a review draft";
    el.body.innerHTML = '<div class="mf-flashcard-status-card"><div class="mf-flashcard-thinking" aria-hidden="true"></div><h3 id="mf-fc-process-title"></h3><p id="mf-fc-process-message" class="mf-flashcard-muted"></p><p class="mf-flashcard-muted">Nothing is being added to your deck yet.</p></div>';
    document.getElementById("mf-fc-process-title").textContent = title;
    document.getElementById("mf-fc-process-message").textContent = message;
  }

  function renderFailure(message) {
    el.saveState.textContent = "No cards were saved";
    el.body.innerHTML = '<div class="mf-flashcard-empty"><h3>That draft did not finish</h3><p id="mf-fc-failure" class="mf-flashcard-muted"></p><button class="mf-flashcard-button is-primary" id="mf-fc-try-again" type="button">Return to Create</button></div>';
    document.getElementById("mf-fc-failure").textContent = message;
    document.getElementById("mf-fc-try-again").addEventListener("click", function () { switchTab("create"); });
  }

  function renderReview() {
    el.reviewCount.textContent = String(state.drafts.filter(function (draft) { return draft.selected && draft.review_status === "approved"; }).length);
    if (!state.user) return renderLoginEmpty(el.body, "Sign in to review private Flashcard drafts.");
    if (!state.drafts.length) {
      el.body.innerHTML = '<div class="mf-flashcard-empty"><h3>No draft waiting</h3><p class="mf-flashcard-muted">Generate cards from Create, then review every card here before saving.</p><button id="mf-fc-go-create" class="mf-flashcard-button is-primary">Create a deck</button></div>';
      document.getElementById("mf-fc-go-create").addEventListener("click", function () { switchTab("create"); }); return;
    }
    el.body.innerHTML = '<div class="mf-flashcard-review-toolbar"><strong id="mf-fc-review-summary"></strong><button class="mf-flashcard-button" id="mf-fc-select-all">Approve all</button><button class="mf-flashcard-button" id="mf-fc-dedupe">Remove duplicates</button><button class="mf-flashcard-button" id="mf-fc-sort">Sort</button><button class="mf-flashcard-button is-primary" id="mf-fc-save-reviewed">Save approved</button></div><div id="mf-fc-review-list" class="mf-flashcard-review-list"></div>';
    renderReviewRows();
    document.getElementById("mf-fc-select-all").addEventListener("click", approveAllDrafts);
    document.getElementById("mf-fc-dedupe").addEventListener("click", dedupeDrafts);
    document.getElementById("mf-fc-sort").addEventListener("click", sortDrafts);
    document.getElementById("mf-fc-save-reviewed").addEventListener("click", saveReviewedDrafts);
  }

  function renderReviewRows() {
    var list = document.getElementById("mf-fc-review-list"); if (!list) return;
    list.innerHTML = "";
    var seen = {};
    state.drafts.forEach(function (draft, index) {
      var key = normalizeCard(draft.front) + "|" + normalizeCard(draft.back);
      var localDuplicate = !!seen[key]; seen[key] = true;
      var article = document.createElement("article"); article.className = "mf-flashcard-review-card" + ((draft.warnings || []).length || localDuplicate || Number(draft.confidence) < .7 ? " has-warning" : "");
      var selected = document.createElement("input"); selected.type = "checkbox"; selected.checked = !!draft.selected && draft.review_status === "approved"; selected.setAttribute("aria-label", "Approve card " + (index + 1));
      selected.addEventListener("change", function () { draft.selected = selected.checked; draft.review_status = selected.checked ? "approved" : "rejected"; scheduleDraftSave(draft); updateReviewSummary(); });
      var content = document.createElement("div"); var fields = document.createElement("div"); fields.className = "mf-flashcard-review-fields";
      var front = labeledTextarea("Front", draft.front, 2000); var back = labeledTextarea("Back", draft.back, 6000);
      var explanation = labeledTextarea("Explanation", draft.explanation || "", 6000); var example = labeledTextarea("Example", draft.example || "", 3000);
      bindDraftInput(front.control, draft, "front"); bindDraftInput(back.control, draft, "back"); bindDraftInput(explanation.control, draft, "explanation"); bindDraftInput(example.control, draft, "example");
      fields.append(front.wrap, back.wrap, explanation.wrap, example.wrap);
      var source = document.createElement("blockquote"); source.className = "mf-flashcard-source-quote";
      source.textContent = sourceReferenceText(draft.source_reference);
      fields.appendChild(source); content.appendChild(fields);
      var meta = document.createElement("div"); meta.className = "mf-flashcard-review-meta";
      meta.append(chip(Math.round(Number(draft.confidence) * 100) + "% confidence", Number(draft.confidence) < .7));
      meta.append(chip(labelize(draft.card_type), false)); meta.append(chip(labelize(draft.difficulty), false));
      if (localDuplicate) meta.append(chip("Possible duplicate", true));
      (draft.warnings || []).forEach(function (warning) { meta.append(chip(String(warning), true)); });
      var actions = document.createElement("div"); actions.className = "mf-flashcard-row-actions"; actions.style.gap = "7px"; actions.style.marginTop = "10px";
      var duplicate = button("Split / copy", "mf-flashcard-button"); var moveUp = button("↑", "mf-flashcard-button"); var moveDown = button("↓", "mf-flashcard-button"); var remove = button("Remove", "mf-flashcard-button is-danger");
      duplicate.addEventListener("click", function () { duplicateDraft(draft); });
      moveUp.setAttribute("aria-label", "Move card " + (index + 1) + " up"); moveDown.setAttribute("aria-label", "Move card " + (index + 1) + " down");
      moveUp.disabled = index === 0; moveDown.disabled = index === state.drafts.length - 1;
      moveUp.addEventListener("click", function () { moveDraft(index, -1); });
      moveDown.addEventListener("click", function () { moveDraft(index, 1); });
      remove.addEventListener("click", function () { draft.selected = false; draft.review_status = "rejected"; scheduleDraftSave(draft, true); renderReview(); });
      actions.append(duplicate, moveUp, moveDown, remove); content.append(meta, actions); article.append(selected, content); list.appendChild(article);
    });
    updateReviewSummary();
  }

  function bindDraftInput(control, draft, fieldName) {
    control.addEventListener("input", function () { draft[fieldName] = control.value; draft.user_edited = true; scheduleDraftSave(draft); });
  }

  function scheduleDraftSave(draft, immediate) {
    clearTimeout(state.saveTimers[draft.id]);
    el.saveState.textContent = "Saving your review…";
    state.saveTimers[draft.id] = setTimeout(function () { saveDraft(draft); }, immediate ? 0 : 650);
  }

  async function saveDraft(draft) {
    if (!state.user) return;
    var oldRevision = draft.revision;
    var payload = { front: String(draft.front || "").slice(0, 2000), back: String(draft.back || "").slice(0, 6000), explanation: String(draft.explanation || "").slice(0, 6000) || null, example: String(draft.example || "").slice(0, 3000) || null, selected: !!draft.selected, review_status: draft.review_status || "pending", user_edited: !!draft.user_edited, revision: oldRevision + 1 };
    var result = await state.bridge.db.from("flashcard_generation_drafts").update(payload).eq("id", draft.id).eq("user_id", state.user.id).eq("revision", oldRevision).select("revision").maybeSingle();
    if (!result.error && result.data) { draft.revision = result.data.revision; el.saveState.textContent = "Review saved"; }
    else { localStorage.setItem("mf-flashcard-draft-" + draft.id, JSON.stringify(payload)); el.saveState.textContent = "Saved on this device; reconnect to sync"; }
  }

  async function approveAllDrafts() {
    state.drafts.forEach(function (draft) { draft.selected = true; draft.review_status = "approved"; });
    await state.bridge.db.from("flashcard_generation_drafts").update({ selected: true, review_status: "approved" }).eq("job_id", state.activeJob.id).eq("user_id", state.user.id).neq("review_status", "imported");
    renderReview();
  }

  function dedupeDrafts() {
    var seen = {}; var removed = 0;
    state.drafts.forEach(function (draft) { var key = normalizeCard(draft.front) + "|" + normalizeCard(draft.back); if (seen[key]) { draft.selected = false; draft.review_status = "rejected"; scheduleDraftSave(draft, true); removed += 1; } else seen[key] = true; });
    toast(removed ? removed + " duplicate" + (removed === 1 ? "" : "s") + " removed from selection." : "No exact duplicates found."); renderReview();
  }

  function sortDrafts() { state.drafts.sort(function (a, b) { return String(a.front).localeCompare(String(b.front)); }); renderReview(); }
  function moveDraft(index, delta) { var target = index + delta; if (target < 0 || target >= state.drafts.length) return; var item = state.drafts.splice(index, 1)[0]; state.drafts.splice(target, 0, item); renderReview(); }

  async function duplicateDraft(draft) {
    if (!state.user || !state.activeJob) return;
    var payload = {
      job_id: state.activeJob.id, user_id: state.user.id, source_id: draft.source_id,
      client_id: "copy_" + crypto.randomUUID(), front: draft.front, back: draft.back,
      explanation: draft.explanation, example: draft.example, formula_latex: draft.formula_latex,
      card_type: draft.card_type, difficulty: draft.difficulty, choices: draft.choices || [],
      correct_choice_id: draft.correct_choice_id, tags: draft.tags || [], source_reference: draft.source_reference || {},
      confidence: draft.confidence, warnings: draft.warnings || [], supplemental: !!draft.supplemental,
      selected: true, review_status: "pending", original_payload: draft.original_payload || {}, user_edited: true
    };
    var result = await state.bridge.db.from("flashcard_generation_drafts").insert(payload).select("*").single();
    if (result.error) return toast(friendlyError(result.error));
    state.drafts.push(result.data); toast("Copy created. Edit both cards to split the idea clearly."); renderReview();
  }

  async function saveReviewedDrafts() {
    if (!state.activeJob) return toast("No generation job is ready.");
    var selected = state.drafts.filter(function (draft) { return draft.selected && draft.review_status === "approved"; });
    if (!selected.length) return toast("Approve at least one card before saving.");
    if (selected.some(function (draft) { return !String(draft.front).trim() || !String(draft.back).trim(); })) return toast("Every selected card needs a front and back.");
    setBusy(true, "Saving approved cards");
    await Promise.all(selected.map(function (draft) { clearTimeout(state.saveTimers[draft.id]); return saveDraft(draft); }));
    var settings = state.activeJob.settings || {};
    var deckDetails = { title: settings.suggested_deck_title || settings.deck_title_hint || "Study deck", subject: settings.suggested_subject || settings.subject_hint || "", course: settings.subject_hint || "", language: settings.language || "en" };
    var result = await state.bridge.db.rpc("confirm_flashcard_generation", { p_job_id: state.activeJob.id, p_draft_ids: selected.map(function (draft) { return draft.id; }), p_deck: deckDetails, p_idempotency_key: "flashcards-" + state.activeJob.id });
    setBusy(false);
    if (result.error) return toast(friendlyError(result.error));
    state.selectedDeckId = result.data.deck_id; await refreshAll(); toast(result.data.saved + " reviewed cards saved."); switchTab("decks");
  }

  function updateReviewSummary() {
    var summary = document.getElementById("mf-fc-review-summary"); var selected = state.drafts.filter(function (draft) { return draft.selected && draft.review_status === "approved"; }).length;
    if (summary) summary.textContent = selected + " of " + state.drafts.length + " approved";
    el.reviewCount.textContent = String(selected);
  }

  async function renderDecks() {
    if (!state.user) return renderLoginEmpty(el.body, "Sign in to view your private deck library.");
    el.body.innerHTML = '<div class="mf-flashcard-view"><div class="mf-flashcard-section-head"><div><h3>Your deck library</h3><p class="mf-flashcard-muted">Search, study, export, schedule, archive, or delete your decks.</p></div><div class="mf-flashcard-source-actions" style="gap:8px"><button id="mf-fc-undo-import" class="mf-flashcard-button">Undo last AI save</button><button id="mf-fc-library-create" class="mf-flashcard-button is-primary">New deck</button></div></div><input id="mf-fc-deck-search" class="mf-flashcard-search" type="search" placeholder="Search decks"><div id="mf-fc-deck-grid" class="mf-flashcard-library-grid"></div><section class="mf-flashcard-panel"><div class="mf-flashcard-section-head"><div><h3>Private source files</h3><p class="mf-flashcard-muted">Sources expire automatically. Removing a source does not delete saved cards.</p></div></div><div id="mf-fc-source-library" class="mf-flashcard-file-list"></div></section></div>';
    document.getElementById("mf-fc-library-create").addEventListener("click", function () { switchTab("create"); });
    document.getElementById("mf-fc-undo-import").addEventListener("click", undoLastImport);
    document.getElementById("mf-fc-deck-search").addEventListener("input", renderDeckGrid);
    renderDeckGrid(); loadSourceLibrary();
  }

  function renderDeckGrid() {
    var grid = document.getElementById("mf-fc-deck-grid"); if (!grid) return;
    var query = (document.getElementById("mf-fc-deck-search").value || "").toLowerCase(); grid.innerHTML = "";
    var decks = state.decks.filter(function (deck) { return !query || (deck.title + " " + deck.subject + " " + deck.course).toLowerCase().indexOf(query) >= 0; });
    if (!decks.length) { var empty = document.createElement("div"); empty.className = "mf-flashcard-empty"; empty.innerHTML = '<h3>No decks found</h3><p class="mf-flashcard-muted">Create a deck or change the search.</p>'; grid.appendChild(empty); return; }
    decks.forEach(function (deck) {
      var cards = cardsForDeck(deck.id); var due = cards.filter(function (card) { return new Date(card.due_at) <= new Date(); }).length;
      var card = document.createElement("article"); card.className = "mf-flashcard-deck-card";
      var title = document.createElement("h3"); var subject = document.createElement("p"); var info = document.createElement("p");
      title.textContent = deck.title; subject.textContent = deck.subject || deck.course || "General study"; info.textContent = cards.length + " cards · " + due + " due";
      var actions = document.createElement("div"); actions.className = "mf-flashcard-row-actions";
      var study = button("Study", "mf-flashcard-button is-primary"); var exportButton = button("Export", "mf-flashcard-button"); var more = button("More", "mf-flashcard-button");
      study.addEventListener("click", function () { state.selectedDeckId = deck.id; persistPreferences(); switchTab("study"); });
      exportButton.addEventListener("click", function () { exportDeck(deck); });
      more.addEventListener("click", function () { showDeckActions(deck, more); });
      actions.append(study, exportButton, more); card.append(title, subject, info, actions); grid.appendChild(card);
    });
  }

  function showDeckActions(deck, anchor) {
    var choice = window.prompt("Type an action: rename, schedule, archive, or delete", "rename");
    if (!choice) return;
    choice = choice.toLowerCase().trim();
    if (choice === "rename") renameDeck(deck);
    else if (choice === "schedule") scheduleDeckReview(deck);
    else if (choice === "archive") archiveDeck(deck);
    else if (choice === "delete") deleteDeck(deck);
    else toast("Choose rename, schedule, archive, or delete.");
  }

  async function renameDeck(deck) {
    var title = window.prompt("Deck name", deck.title); if (!title || !title.trim()) return;
    var result = await state.bridge.db.from("flashcard_decks").update({ title: title.trim().slice(0, 160), revision: Number(deck.revision || 1) + 1 }).eq("id", deck.id).eq("user_id", state.user.id);
    if (result.error) return toast(friendlyError(result.error)); await refreshAll(); toast("Deck renamed.");
  }

  async function scheduleDeckReview(deck) {
    var date = window.prompt("Review date (YYYY-MM-DD)", new Date(Date.now() + 86400000).toISOString().slice(0, 10));
    if (!date || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return;
    if (!window.confirm("Add “Review " + deck.title + "” to your Study Calendar for " + date + "?")) return;
    var result = await state.bridge.db.from("schedule_events").insert({ user_id: state.user.id, title: "Review " + deck.title, course: deck.subject || deck.course || "", event_type: "assignment", event_date: date, all_day: true, status: "todo", priority: "medium", source_kind: "flashcards", source_flashcard_deck_id: deck.id, notes: "Flashcard review session" });
    if (result.error) return toast(friendlyError(result.error));
    if (state.bridge.refreshCalendar) await state.bridge.refreshCalendar(); toast("Review added to the Study Calendar.");
  }

  async function archiveDeck(deck) { if (!window.confirm("Archive “" + deck.title + "”? You can keep its data without showing it in the active library.")) return; var result = await state.bridge.db.from("flashcard_decks").update({ archived_at: new Date().toISOString() }).eq("id", deck.id).eq("user_id", state.user.id); if (result.error) return toast(friendlyError(result.error)); await refreshAll(); toast("Deck archived."); }
  async function deleteDeck(deck) { if (!window.confirm("Delete “" + deck.title + "” and all of its cards? This cannot be undone.")) return; var result = await state.bridge.db.from("flashcard_decks").update({ deleted_at: new Date().toISOString() }).eq("id", deck.id).eq("user_id", state.user.id); if (result.error) return toast(friendlyError(result.error)); await refreshAll(); toast("Deck deleted."); }

  async function undoLastImport() { if (!requireLogin()) return; if (!window.confirm("Remove the cards from your most recent AI save?")) return; var result = await state.bridge.db.rpc("undo_last_flashcard_import"); if (result.error) return toast(friendlyError(result.error)); await refreshAll(); toast(result.data.cards_removed + " cards removed. The reviewed draft is available again."); if (state.activeJob) await loadJobDrafts(state.activeJob.id); }

  async function loadSourceLibrary() {
    var result = await state.bridge.db.from("flashcard_sources").select("*").eq("user_id", state.user.id).is("deleted_at", null).order("created_at", { ascending: false }).limit(30);
    state.sources = result.data || []; var list = document.getElementById("mf-fc-source-library"); if (!list) return; list.innerHTML = "";
    if (!state.sources.length) { var empty = document.createElement("p"); empty.className = "mf-flashcard-muted"; empty.textContent = "No retained sources."; list.appendChild(empty); return; }
    state.sources.forEach(function (source) {
      var row = document.createElement("div"); row.className = "mf-flashcard-file-row"; var info = document.createElement("div"); var name = document.createElement("strong"); var status = document.createElement("small"); var remove = button("Delete source", "mf-flashcard-button is-danger");
      name.textContent = source.original_name; status.textContent = labelize(source.source_type) + " · expires " + new Date(source.expires_at).toLocaleDateString(); info.append(name, status); row.append(info, remove);
      remove.addEventListener("click", function () { deleteSource(source); }); list.appendChild(row);
    });
  }

  async function deleteSource(source) {
    if (!window.confirm("Delete this private source file? Saved flashcards will remain, but source references may no longer open.")) return;
    var result = await state.bridge.db.rpc("delete_flashcard_source", { p_source_id: source.id });
    if (result.error) return toast(friendlyError(result.error));
    if (result.data.storage_path) await state.bridge.db.storage.from("flashcard-sources").remove([result.data.storage_path]);
    toast("Private source deleted."); loadSourceLibrary();
  }

  function exportDeck(deck) {
    var payload = { version: 1, title: deck.title, subject: deck.subject, cards: cardsForDeck(deck.id).map(function (card) { return { front: card.front, back: card.back, explanation: card.explanation, example: card.example, tags: card.tags }; }) };
    downloadFile(safeFileName(deck.title) + ".json", JSON.stringify(payload, null, 2), "application/json");
  }

  function renderStudy() {
    if (!state.user) return renderLoginEmpty(el.body, "Sign in to study saved decks and keep your progress.");
    if (state.study && state.study.cards.length) return renderStudyCard();
    if (!state.decks.length) {
      el.body.innerHTML = '<div class="mf-flashcard-empty"><h3>No deck to study yet</h3><p class="mf-flashcard-muted">Create or import a deck first.</p><button id="mf-fc-study-create" class="mf-flashcard-button is-primary">Create a deck</button></div>';
      document.getElementById("mf-fc-study-create").addEventListener("click", function () { switchTab("create"); }); return;
    }
    el.body.innerHTML = '<div class="mf-flashcard-view"><div class="mf-flashcard-panel"><h3>Start a study session</h3><div class="mf-flashcard-form-grid">' + field("Deck", '<select id="mf-fc-study-deck"></select>') + field("Mode", '<select id="mf-fc-study-mode"><option value="standard">Standard</option><option value="quick">Quick 10</option><option value="learn">Learn</option><option value="test">Test</option><option value="shuffle">Shuffle</option><option value="difficult">Difficult cards</option><option value="due">Due cards</option><option value="cram">Cram (no schedule changes)</option></select>') + '</div><div class="mf-flashcard-source-actions" style="gap:9px;margin-top:16px"><button id="mf-fc-start-study" class="mf-flashcard-button is-primary">Start studying</button><button id="mf-fc-study-pomodoro" class="mf-flashcard-button">Start 25-minute Pomodoro</button></div><p class="mf-flashcard-muted" style="margin-bottom:0">Keyboard: Space flips · 1–4 rate · left/right moves.</p></div></div>';
    var select = document.getElementById("mf-fc-study-deck"); state.decks.forEach(function (deck) { var option = document.createElement("option"); option.value = deck.id; option.textContent = deck.title; select.appendChild(option); }); select.value = state.selectedDeckId || state.decks[0].id;
    document.getElementById("mf-fc-start-study").addEventListener("click", startStudySession);
    document.getElementById("mf-fc-study-pomodoro").addEventListener("click", function () { if (state.bridge.startPomodoro) { state.bridge.startPomodoro(25, "focus"); toast("Pomodoro started in the lounge."); } });
  }

  async function startStudySession() {
    var deckId = document.getElementById("mf-fc-study-deck").value; var mode = document.getElementById("mf-fc-study-mode").value; var cards = cardsForDeck(deckId).slice(); var now = new Date();
    if (mode === "due") cards = cards.filter(function (card) { return new Date(card.due_at) <= now; });
    if (mode === "difficult") cards = cards.filter(function (card) { return Number(card.lapse_count || 0) > 0 || card.difficulty === "advanced"; });
    if (mode === "quick") cards = cards.slice(0, 10);
    if (["shuffle", "cram", "test"].indexOf(mode) >= 0) shuffle(cards);
    if (!cards.length) return toast("No cards match that study mode right now.");
    var session = await state.bridge.db.from("flashcard_study_sessions").insert({ user_id: state.user.id, deck_id: deckId, mode: mode }).select("*").single();
    if (session.error) return toast(friendlyError(session.error));
    state.study = { id: session.data.id, deckId: deckId, mode: mode, cards: cards, index: 0, flipped: false, seen: 0, correct: 0, incorrect: 0 };
    state.selectedDeckId = deckId; persistPreferences(); renderStudyCard();
  }

  function renderStudyCard() {
    var study = state.study; if (!study || !study.cards.length) return renderStudy(); var card = study.cards[study.index];
    el.body.innerHTML = '<div class="mf-flashcard-study-shell"><div class="mf-flashcard-study-top"><strong id="mf-fc-study-position"></strong><button id="mf-fc-end-study" class="mf-flashcard-button">End session</button></div><div class="mf-flashcard-study-progress"><span id="mf-fc-study-progress"></span></div><div id="mf-fc-study-card" class="mf-flashcard-study-card" role="button" tabindex="0" aria-label="Flip flashcard"><div class="mf-flashcard-study-inner"><section class="mf-flashcard-study-face"><small>Question</small><h3 id="mf-fc-study-front"></h3><p class="mf-flashcard-muted">Tap or press Space to reveal</p></section><section class="mf-flashcard-study-face is-back"><small>Answer</small><h3 id="mf-fc-study-back"></h3><p id="mf-fc-study-explanation"></p></section></div></div><div id="mf-fc-ratings" class="mf-flashcard-rating-grid" hidden><button data-fc-rating="again">1 · Again</button><button data-fc-rating="hard">2 · Hard</button><button data-fc-rating="good">3 · Good</button><button data-fc-rating="easy">4 · Easy</button></div><div class="mf-flashcard-study-controls"><button id="mf-fc-prev" class="mf-flashcard-button">← Previous</button><button id="mf-fc-flip" class="mf-flashcard-button is-primary">Show answer</button><button id="mf-fc-next" class="mf-flashcard-button">Next →</button></div></div>';
    document.getElementById("mf-fc-study-position").textContent = (study.index + 1) + " of " + study.cards.length;
    document.getElementById("mf-fc-study-progress").style.width = ((study.index / study.cards.length) * 100) + "%";
    document.getElementById("mf-fc-study-front").textContent = card.front; document.getElementById("mf-fc-study-back").textContent = card.back;
    document.getElementById("mf-fc-study-explanation").textContent = card.explanation || card.example || "";
    var cardNode = document.getElementById("mf-fc-study-card"); cardNode.addEventListener("click", flipStudyCard);
    document.getElementById("mf-fc-flip").addEventListener("click", flipStudyCard);
    document.getElementById("mf-fc-prev").addEventListener("click", function () { if (study.index > 0) { study.index -= 1; study.flipped = false; renderStudyCard(); } });
    document.getElementById("mf-fc-next").addEventListener("click", function () { advanceStudy("good", false); });
    document.getElementById("mf-fc-end-study").addEventListener("click", finishStudy);
    document.querySelectorAll("[data-fc-rating]").forEach(function (button) { button.addEventListener("click", function () { rateStudyCard(button.dataset.fcRating); }); });
    if (study.flipped) applyStudyFlip();
  }

  function flipStudyCard() { if (!state.study) return; state.study.flipped = !state.study.flipped; applyStudyFlip(); }
  function applyStudyFlip() { var card = document.getElementById("mf-fc-study-card"); var ratings = document.getElementById("mf-fc-ratings"); var flip = document.getElementById("mf-fc-flip"); if (!card) return; card.classList.toggle("is-flipped", state.study.flipped); ratings.hidden = !state.study.flipped; flip.textContent = state.study.flipped ? "Show question" : "Show answer"; }

  async function rateStudyCard(rating) {
    var study = state.study; if (!study) return; var card = study.cards[study.index]; var affect = study.mode !== "cram";
    var result = await state.bridge.db.rpc("rate_flashcard", { p_card_id: card.id, p_rating: rating, p_session_id: study.id, p_affect_schedule: affect });
    if (result.error) return toast(friendlyError(result.error));
    study.seen += 1; if (rating === "again") study.incorrect += 1; else study.correct += 1; advanceStudy(rating, true);
  }

  function advanceStudy(rating, rated) { var study = state.study; if (!study) return; if (study.index >= study.cards.length - 1) return finishStudy(); study.index += 1; study.flipped = false; renderStudyCard(); }
  async function finishStudy() { var study = state.study; if (!study) return; await state.bridge.db.from("flashcard_study_sessions").update({ cards_seen: study.seen, correct_count: study.correct, incorrect_count: study.incorrect, completed_at: new Date().toISOString() }).eq("id", study.id).eq("user_id", state.user.id); state.study = null; await refreshAll(); toast("Study session complete."); renderStudy(); }

  function handleGlobalKeys(event) {
    if (el.studio && !el.studio.hidden) {
      if (event.key === "Escape") return closeStudio();
      if (event.key === "Tab") trapFocus(event);
      if (state.activeTab === "study" && state.study && !/INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) {
        if (event.code === "Space") { event.preventDefault(); flipStudyCard(); }
        else if (event.key === "ArrowLeft" && state.study.index > 0) { state.study.index -= 1; state.study.flipped = false; renderStudyCard(); }
        else if (event.key === "ArrowRight") advanceStudy("good", false);
        else if (["1", "2", "3", "4"].indexOf(event.key) >= 0 && state.study.flipped) rateStudyCard(["again", "hard", "good", "easy"][Number(event.key) - 1]);
      }
    }
  }

  function trapFocus(event) {
    var focusable = Array.prototype.slice.call(el.panel.querySelectorAll('button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex="0"]')).filter(function (node) { return node.offsetParent !== null; });
    var menuToggle = document.getElementById("mf-quick-menu-toggle");
    var menuPanel = document.getElementById("mf-quick-menu-panel");
    if (menuToggle && menuToggle.offsetParent !== null) focusable.push(menuToggle);
    if (menuPanel && !menuPanel.hidden) {
      Array.prototype.slice.call(menuPanel.querySelectorAll("button, a")).forEach(function (node) {
        if (node.offsetParent !== null) focusable.push(node);
      });
    }
    if (!focusable.length) return; var first = focusable[0]; var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function showHelp() { toast("Create: choose a source and settings. Review: edit every AI draft. Decks: manage saved cards. Study: flip and rate with Again, Hard, Good, or Easy.", 6500); }
  function openNasuForFlashcards() { var launcher = document.getElementById("mf-nasu-launcher"); closeStudio(); if (launcher) launcher.click(); window.setTimeout(function () { var input = document.getElementById("mf-nasu-input"); if (input) { input.value = "Help me plan a flashcard deck from my study materials."; input.focus(); } }, 150); }
  function setNasuState(name) { window.dispatchEvent(new CustomEvent("memoryfuel:nasu-state", { detail: { state: name, source: "flashcards" } })); }

  function renderLoginEmpty(container, message) { container.innerHTML = '<div class="mf-flashcard-empty"><h3>Study account required</h3><p id="mf-fc-login-message" class="mf-flashcard-muted"></p><button id="mf-fc-login" class="mf-flashcard-button is-primary">Sign in</button></div>'; document.getElementById("mf-fc-login-message").textContent = message; document.getElementById("mf-fc-login").addEventListener("click", function () { closeStudio(); var account = document.getElementById("mf-account-toggle"); if (account) account.click(); }); }
  function requireLogin(show) { if (state.user) return true; if (show !== false) { toast("Sign in to keep Flashcards private and synced."); var account = document.getElementById("mf-account-toggle"); if (account) account.click(); } return false; }
  function setBusy(busy, label) { state.busy = busy; el.saveState.textContent = label || (busy ? "Working securely…" : "Ready when you are"); }

  function labeledTextarea(label, value, max) { var wrap = document.createElement("label"); wrap.className = "mf-flashcard-field"; var span = document.createElement("span"); span.textContent = label; var control = document.createElement("textarea"); control.maxLength = max; control.value = value || ""; wrap.append(span, control); return { wrap: wrap, control: control }; }
  function chip(text, warning) { var node = document.createElement("span"); node.className = "mf-flashcard-chip" + (warning ? " is-warning" : ""); node.textContent = text; return node; }
  function button(text, className) { var node = document.createElement("button"); node.type = "button"; node.className = className; node.textContent = text; return node; }
  function cardsForDeck(id) { return state.cards.filter(function (card) { return card.deck_id === id && !card.deleted_at; }); }
  function sourceReferenceText(value) { if (!value || typeof value !== "object") return "Source reference unavailable"; var parts = []; if (value.source_name) parts.push(value.source_name); if (value.page) parts.push("page " + value.page); var excerpt = value.excerpt || value.exact_text; if (excerpt) parts.push("“" + String(excerpt).slice(0, 420) + "”"); return parts.join(" · ") || "Source reference unavailable"; }
  function labelize(value) { return String(value || "").replace(/_/g, " ").replace(/\b\w/g, function (letter) { return letter.toUpperCase(); }); }
  function normalizeCard(value) { return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, ""); }
  function formatBytes(bytes) { if (bytes < 1024) return bytes + " B"; if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB"; return (bytes / 1048576).toFixed(1) + " MB"; }
  function safeExtension(name) { var ext = (String(name).split(".").pop() || "bin").toLowerCase().replace(/[^a-z0-9]/g, ""); return ext || "bin"; }
  function safeFileName(name) { return String(name || "deck").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "deck"; }
  function friendlyError(error) { var message = error && (error.message || (error.context && error.context.message)) ? String(error.message || error.context.message) : String(error || "Something went wrong."); if (/JWT|session|auth/i.test(message)) return "Your login expired. Sign in and try again."; if (/limit/i.test(message)) return "You reached the current generation limit. Existing decks still work normally."; if (/duplicate/i.test(message)) return "An identical source or card already exists. Review the existing item instead."; return message.slice(0, 260); }

  async function normalizeFunctionError(error) {
    var fallback = friendlyError(error);
    var response = error && error.context;
    if (!response || typeof response.clone !== "function") return new Error(fallback);
    try {
      var copy = response.clone();
      var text = await copy.text();
      var payload = text ? JSON.parse(text) : {};
      var code = String(payload.code || "");
      var message = String(payload.error || fallback);
      var safe = {
        source_download_failed: "That private source file is no longer available. Select the file again and retry.",
        invalid_file: "That source file could not be verified. Choose a supported PDF, image, or text file and retry.",
        invalid_pdf: "That PDF is damaged or password protected. Choose an unlocked PDF and retry.",
        too_many_pages: "PDF sources may contain no more than 25 pages total.",
        too_many_images: "Select no more than 10 images.",
        invalid_text: "That text source is empty or too long.",
        unauthorized: "Your login expired. Sign in and try again.",
        rate_limited: "You reached the current generation limit. Existing decks still work normally.",
        processing_failed: "Nasú could not finish this deck. Your source was not imported, so it is safe to retry."
      }[code] || message;
      var normalized = new Error(safe.slice(0, 260));
      normalized.code = code;
      return normalized;
    } catch (parseError) {
      return new Error(fallback);
    }
  }

  function toast(message, duration) { clearTimeout(state.toastTimer); el.toast.textContent = message; el.toast.hidden = false; state.toastTimer = setTimeout(function () { el.toast.hidden = true; }, duration || 4200); }
  function shuffle(items) { for (var i = items.length - 1; i > 0; i -= 1) { var j = Math.floor(Math.random() * (i + 1)); var temp = items[i]; items[i] = items[j]; items[j] = temp; } return items; }
  function stableStringify(value) { if (value === null || typeof value !== "object") return JSON.stringify(value); if (Array.isArray(value)) return "[" + value.map(stableStringify).join(",") + "]"; return "{" + Object.keys(value).sort().map(function (key) { return JSON.stringify(key) + ":" + stableStringify(value[key]); }).join(",") + "}"; }
  async function sha256Text(value) { return digestHex(new TextEncoder().encode(value)); }
  async function sha256Blob(blob) { return digestHex(await blob.arrayBuffer()); }
  async function digestHex(buffer) { var hash = await crypto.subtle.digest("SHA-256", buffer); return Array.from(new Uint8Array(hash)).map(function (byte) { return byte.toString(16).padStart(2, "0"); }).join(""); }
  function downloadFile(name, content, type) { var blob = new Blob([content], { type: type }); var url = URL.createObjectURL(blob); var link = document.createElement("a"); link.href = url; link.download = name; document.body.appendChild(link); link.click(); link.remove(); setTimeout(function () { URL.revokeObjectURL(url); }, 1000); }
  function parseJsonDeck(text) { var value = JSON.parse(text); var cards = Array.isArray(value) ? value : value.cards; if (!Array.isArray(cards)) throw new Error("missing_cards"); return { title: value.title || "Imported deck", subject: value.subject || "", cards: cards.filter(function (card) { return card && card.front && card.back; }) }; }
  function parseCsvDeck(text) { var rows = parseCsv(text); if (rows.length < 2) throw new Error("empty_csv"); var headers = rows.shift().map(function (item) { return item.toLowerCase().trim(); }); var frontIndex = headers.indexOf("front"); var backIndex = headers.indexOf("back"); if (frontIndex < 0 || backIndex < 0) throw new Error("headers"); return { title: "Imported deck", subject: "", cards: rows.filter(function (row) { return row[frontIndex] && row[backIndex]; }).map(function (row) { return { front: row[frontIndex], back: row[backIndex], explanation: "" }; }) }; }
  function parseCsv(text) { var rows = []; var row = []; var cell = ""; var quoted = false; for (var i = 0; i < text.length; i += 1) { var char = text[i]; if (quoted) { if (char === '"' && text[i + 1] === '"') { cell += '"'; i += 1; } else if (char === '"') quoted = false; else cell += char; } else if (char === '"') quoted = true; else if (char === ",") { row.push(cell); cell = ""; } else if (char === "\n") { row.push(cell.replace(/\r$/, "")); rows.push(row); row = []; cell = ""; } else cell += char; } row.push(cell.replace(/\r$/, "")); if (row.some(Boolean)) rows.push(row); return rows; }
})();
